<div>
    <p>{{ 'auth.message.passwordChangeMessage' | translate }}</p>
</div>
<form #form
      [formGroup]='forgotPasswordForm'>
    <div class="credentials-content">
        <app-input
            type="password"
            [formControl]="forgotPasswordForm.controls.password"
            [isDisabled]="inputDisabled"
            [showErrors]="showValidations"
            (inputChange)="resetMissmatchError()"
            [placeholder]="'auth.passwordLabel' | translate"
            [label]="'auth.passwordLabel' | translate">
        </app-input>

        <app-input
            type="password"
            [isDisabled]="inputDisabled"
            [formControl]="forgotPasswordForm.controls.passwordConfirmation"
            [showErrors]="showValidations"
            (inputChange)="resetMissmatchError()"
            [placeholder]="'auth.confirmPasswordLabel' | translate"
            [label]="'auth.confirmPasswordLabel' | translate">
        </app-input>
    </div>
    <app-alert *ngIf="forgotPasswordError" type="error"
               responsive="true"
               message="{{ 'auth.passwordNotMatching' | translate }}"></app-alert>
    <app-button type="primary"
                (click)="onSubmitForgotPassword()"
                [disabled]="showValidations && !forgotPasswordForm.valid && forgotPasswordForm.touched">
        {{ 'auth.buttons.send' | translate }}
    </app-button>

    <a routerLink="/auth">{{ 'auth.buttons.back' | translate }}</a>
</form>

<app-confirmation-modal
    (scanEvent)="onConfirmForgotPassword($event)"
    title="{{'auth.message.popupTitle' | translate}}"
    question="{{'auth.message.popupQuestion' | translate}}"
    message="{{'auth.message.popupMessage' | translate}}">
</app-confirmation-modal>
